import consoleStyles from '../utils/consoleStyles';
import Vue from "vue";
import router from '../plugins/router'

export default {
    // setPageTitle({commit}, title){
    //     commit('SET_PAGE_TITLE', title);
    // },
    // setPageActions({commit}, actions = null){
    //     commit('SET_PAGE_ACTIONS', {actions, extra });
    // },
    setNavigation({commit}, payload = true){
        commit('SET_NAVIGATION', payload);
    },
    setSidebar({commit}, payload){
        commit('SET_SIDEBAR', payload);
    },
    appCommand( _, {type, items} ){

        console.log("%cApp Command : " + type , consoleStyles.appCommand );
        if( items )
            console.table(items);

        const json = JSON.stringify({
            type: type,
            items: items
        });

        if(process.env.NODE_ENV !== 'production')
            return;

        AppCommand.postMessage(json);
    },
    async eventFromApp({dispatch}) {

        if (!window.appEventData)
            return;

        const type = window.appEventData.type;
        const params = window.appEventData.params;

        if (type === 'notif') {
            dispatch('popup/showNotif', {
                message: decodeURIComponent(params.message),
                title: decodeURIComponent(params.title),
                path: params.path
            }, {root: true});
        } else if (type === 'payback') {
            const paidParams = JSON.parse(params);
            await router.replace('/transaction/payback/?' + 'status=' + paidParams.status + '&transaction=' + paidParams.transaction);
        } else if (type === 'imageSelected') {
            dispatch('appImageLoaded', params.image); // using for subscribes in image uploads
        } else if (type === 'initial') {
            dispatch('init/appInitialize', null, {root: true}); // subscribes in image uploads
        }

        window.appEventData = null;
    },
    setApiCache({commit}, {key, data} ){

        commit('SET_API_CACHE', {
            key: key,
            params: {
                data: data,
                time: Vue.prototype.$helpers.currentTime()
            }
        });
    },
    fetchApiCache({state,commit}, key ){

        let cacheData = null;
        let cacheTime = null;
        let cacheKey = null;
        if(key.includes('/')){
            const keyParts = key.split('/');
            cacheKey = keyParts[0];
            if(cacheKey in state.apiCache)
                if(keyParts[1] in state.apiCache[cacheKey]['data']){
                    cacheData = state.apiCache[cacheKey]['data'][keyParts[1]];
                    cacheTime = state.apiCache[cacheKey]['time']
                }
        }else if(key in state.apiCache){
            cacheKey = key;
            cacheData = state.apiCache[cacheKey]['data'];
            cacheTime = state.apiCache[cacheKey]['time'];
        }

        if(cacheData){
            const passedTime = parseInt(Vue.prototype.$helpers.currentTime()) - parseInt(cacheTime);
            if(passedTime > 300){ // 5 min
                commit('REMOVE_API_CACHE', cacheKey);
                return null;
            }
        }

        return cacheData;
    },
    updateSettings({commit}, payload ){
        commit('UPDATE_SETTINGS', payload)
    }
}